const content: { [key: string]: string } = {
  previousArrowLabel: "Previous Period",
  nextArrowLabel: "Next Period",
  selected: "Selected",
  bonusPeriodList: "List of Bonus Period",
  selectPeriod: "Select a bonus period",
  performanceYear: `PY{performanceYear}`,
};

export default content;
